function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { InjectionToken, Injectable, NgZone, Optional, Inject, Pipe, NgModule } from '@angular/core';
import { ApolloClient } from 'apollo-client';
import { Observable, queueScheduler, observable, from } from 'rxjs';
import { observeOn, startWith } from 'rxjs/operators';
function fromPromise(promiseFn) {
  return new Observable(function (subscriber) {
    promiseFn().then(function (result) {
      if (!subscriber.closed) {
        subscriber.next(result);
        subscriber.complete();
      }
    }, function (error) {
      if (!subscriber.closed) {
        subscriber.error(error);
      }
    });
    return function () {
      return subscriber.unsubscribe();
    };
  });
}
var ZoneScheduler = /*#__PURE__*/function () {
  function ZoneScheduler(zone) {
    _classCallCheck(this, ZoneScheduler);
    this.zone = zone;
    this.now = Date.now ? Date.now : function () {
      return +new Date();
    };
  }
  _createClass(ZoneScheduler, [{
    key: "schedule",
    value: function schedule(work) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var state = arguments.length > 2 ? arguments[2] : undefined;
      return this.zone.run(function () {
        return queueScheduler.schedule(work, delay, state);
      });
    }
  }]);
  return ZoneScheduler;
}(); // XXX: Apollo's QueryObservable is not compatible with RxJS
// TODO: remove it in one of future releases
// https://github.com/ReactiveX/rxjs/blob/9fb0ce9e09c865920cf37915cc675e3b3a75050b/src/internal/util/subscribeTo.ts#L32
function fixObservable(obs) {
  obs[observable] = function () {
    return obs;
  };
  return obs;
}
function wrapWithZone(obs, ngZone) {
  return obs.pipe(observeOn(new ZoneScheduler(ngZone)));
}
var QueryRef = /*#__PURE__*/function () {
  function QueryRef(obsQuery, ngZone, options) {
    _classCallCheck(this, QueryRef);
    this.obsQuery = obsQuery;
    var wrapped = wrapWithZone(from(fixObservable(this.obsQuery)), ngZone);
    this.valueChanges = options.useInitialLoading ? wrapped.pipe(startWith(Object.assign(Object.assign({}, this.obsQuery.getCurrentResult()), {
      error: undefined,
      partial: undefined,
      stale: true
    }))) : wrapped;
    this.queryId = this.obsQuery.queryId;
  }
  // ObservableQuery's methods
  _createClass(QueryRef, [{
    key: "result",
    value: function result() {
      return this.obsQuery.result();
    }
  }, {
    key: "currentResult",
    value: function currentResult() {
      return this.obsQuery.currentResult();
    }
  }, {
    key: "getLastResult",
    value: function getLastResult() {
      return this.obsQuery.getLastResult();
    }
  }, {
    key: "getLastError",
    value: function getLastError() {
      return this.obsQuery.getLastError();
    }
  }, {
    key: "resetLastResults",
    value: function resetLastResults() {
      return this.obsQuery.resetLastResults();
    }
  }, {
    key: "refetch",
    value: function refetch(variables) {
      return this.obsQuery.refetch(variables);
    }
  }, {
    key: "fetchMore",
    value: function fetchMore(fetchMoreOptions) {
      return this.obsQuery.fetchMore(fetchMoreOptions);
    }
  }, {
    key: "subscribeToMore",
    value: function subscribeToMore(options) {
      // XXX: there's a bug in apollo-client typings
      // it should not inherit types from ObservableQuery
      return this.obsQuery.subscribeToMore(options);
    }
  }, {
    key: "updateQuery",
    value: function updateQuery(mapFn) {
      return this.obsQuery.updateQuery(mapFn);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      return this.obsQuery.stopPolling();
    }
  }, {
    key: "startPolling",
    value: function startPolling(pollInterval) {
      return this.obsQuery.startPolling(pollInterval);
    }
  }, {
    key: "setOptions",
    value: function setOptions(opts) {
      return this.obsQuery.setOptions(opts);
    }
  }, {
    key: "setVariables",
    value: function setVariables(variables) {
      var tryFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var fetchResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return this.obsQuery.setVariables(variables, tryFetch, fetchResults);
    }
  }]);
  return QueryRef;
}();
var APOLLO_OPTIONS = new InjectionToken('[apollo-angular] options');
var APOLLO_NAMED_OPTIONS = new InjectionToken('[apollo-angular] named options');
var ApolloBase = /*#__PURE__*/function () {
  function ApolloBase(ngZone, _client) {
    _classCallCheck(this, ApolloBase);
    this.ngZone = ngZone;
    this._client = _client;
  }
  _createClass(ApolloBase, [{
    key: "watchQuery",
    value: function watchQuery(options) {
      return new QueryRef(this.ensureClient().watchQuery(Object.assign({}, options)), this.ngZone, options);
    }
  }, {
    key: "query",
    value: function query(options) {
      var _this = this;
      return fromPromise(function () {
        return _this.ensureClient().query(Object.assign({}, options));
      });
    }
  }, {
    key: "mutate",
    value: function mutate(options) {
      var _this2 = this;
      return fromPromise(function () {
        return _this2.ensureClient().mutate(Object.assign({}, options));
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(options, extra) {
      var obs = from(fixObservable(this.ensureClient().subscribe(Object.assign({}, options))));
      return extra && extra.useZone !== true ? obs : wrapWithZone(obs, this.ngZone);
    }
    /**
     * Get an access to an instance of ApolloClient
     */
  }, {
    key: "getClient",
    value: function getClient() {
      return this._client;
    }
    /**
     * Set a new instance of ApolloClient
     * Remember to clean up the store before setting a new client.
     *
     * @param client ApolloClient instance
     */
  }, {
    key: "setClient",
    value: function setClient(client) {
      if (this._client) {
        throw new Error('Client has been already defined');
      }
      this._client = client;
    }
  }, {
    key: "ensureClient",
    value: function ensureClient() {
      this.checkInstance();
      return this._client;
    }
  }, {
    key: "checkInstance",
    value: function checkInstance() {
      if (!this._client) {
        throw new Error('Client has not been defined yet');
      }
    }
  }]);
  return ApolloBase;
}();
var Apollo = /*#__PURE__*/function (_ApolloBase) {
  _inherits(Apollo, _ApolloBase);
  var _super = _createSuper(Apollo);
  function Apollo(_ngZone, apolloOptions, apolloNamedOptions) {
    var _this3;
    _classCallCheck(this, Apollo);
    _this3 = _super.call(this, _ngZone);
    _this3._ngZone = _ngZone;
    _this3.map = new Map();
    if (apolloOptions) {
      _this3.createDefault(apolloOptions);
    }
    if (apolloNamedOptions && _typeof(apolloNamedOptions) === 'object') {
      for (var name in apolloNamedOptions) {
        if (apolloNamedOptions.hasOwnProperty(name)) {
          var options = apolloNamedOptions[name];
          _this3.createNamed(name, options);
        }
      }
    }
    return _this3;
  }
  /**
   * Create an instance of ApolloClient
   * @param options Options required to create ApolloClient
   * @param name client's name
   */
  _createClass(Apollo, [{
    key: "create",
    value: function create(options, name) {
      if (isDefault(name)) {
        this.createDefault(options);
      } else {
        this.createNamed(name, options);
      }
    }
    /**
     * Use a default ApolloClient
     */
  }, {
    key: "default",
    value: function _default() {
      return this;
    }
    /**
     * Use a named ApolloClient
     * @param name client's name
     */
  }, {
    key: "use",
    value: function use(name) {
      if (isDefault(name)) {
        return this["default"]();
      }
      return this.map.get(name);
    }
    /**
     * Create a default ApolloClient, same as `apollo.create(options)`
     * @param options ApolloClient's options
     */
  }, {
    key: "createDefault",
    value: function createDefault(options) {
      if (this.getClient()) {
        throw new Error('Apollo has been already created.');
      }
      return this.setClient(new ApolloClient(options));
    }
    /**
     * Create a named ApolloClient, same as `apollo.create(options, name)`
     * @param name client's name
     * @param options ApolloClient's options
     */
  }, {
    key: "createNamed",
    value: function createNamed(name, options) {
      if (this.map.has(name)) {
        throw new Error("Client ".concat(name, " has been already created"));
      }
      this.map.set(name, new ApolloBase(this._ngZone, new ApolloClient(options)));
    }
    /**
     * Remember to clean up the store before removing a client
     * @param name client's name
     */
  }, {
    key: "removeClient",
    value: function removeClient(name) {
      if (isDefault(name)) {
        this._client = undefined;
      } else {
        this.map["delete"](name);
      }
    }
  }]);
  return Apollo;
}(ApolloBase);
Apollo.decorators = [{
  type: Injectable
}];
Apollo.ctorParameters = function () {
  return [{
    type: NgZone
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [APOLLO_OPTIONS]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [APOLLO_NAMED_OPTIONS]
    }]
  }];
};
function isDefault(name) {
  return !name || name === 'default';
}
var Query = /*#__PURE__*/function () {
  function Query(apollo) {
    _classCallCheck(this, Query);
    this.apollo = apollo;
    this.client = 'default';
  }
  _createClass(Query, [{
    key: "watch",
    value: function watch(variables, options) {
      return this.apollo.use(this.client).watchQuery(Object.assign(Object.assign({}, options), {
        variables: variables,
        query: this.document
      }));
    }
  }, {
    key: "fetch",
    value: function fetch(variables, options) {
      return this.apollo.use(this.client).query(Object.assign(Object.assign({}, options), {
        variables: variables,
        query: this.document
      }));
    }
  }]);
  return Query;
}();
Query.decorators = [{
  type: Injectable
}];
Query.ctorParameters = function () {
  return [{
    type: Apollo
  }];
};
var Mutation = /*#__PURE__*/function () {
  function Mutation(apollo) {
    _classCallCheck(this, Mutation);
    this.apollo = apollo;
    this.client = 'default';
  }
  _createClass(Mutation, [{
    key: "mutate",
    value: function mutate(variables, options) {
      return this.apollo.use(this.client).mutate(Object.assign(Object.assign({}, options), {
        variables: variables,
        mutation: this.document
      }));
    }
  }]);
  return Mutation;
}();
Mutation.decorators = [{
  type: Injectable
}];
Mutation.ctorParameters = function () {
  return [{
    type: Apollo
  }];
};
var Subscription = /*#__PURE__*/function () {
  function Subscription(apollo) {
    _classCallCheck(this, Subscription);
    this.apollo = apollo;
    this.client = 'default';
  }
  _createClass(Subscription, [{
    key: "subscribe",
    value: function subscribe(variables, options, extra) {
      return this.apollo.use(this.client).subscribe(Object.assign(Object.assign({}, options), {
        variables: variables,
        query: this.document
      }), extra);
    }
  }]);
  return Subscription;
}();
Subscription.decorators = [{
  type: Injectable
}];
Subscription.ctorParameters = function () {
  return [{
    type: Apollo
  }];
};
var SelectPipe = /*#__PURE__*/function () {
  function SelectPipe() {
    _classCallCheck(this, SelectPipe);
  }
  _createClass(SelectPipe, [{
    key: "transform",
    value: function transform(obj) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (name !== '') {
        return obj && obj.data && obj.data[name];
      }
    }
  }]);
  return SelectPipe;
}();
SelectPipe.decorators = [{
  type: Pipe,
  args: [{
    name: 'select'
  }]
}];
var PROVIDERS = [Apollo];
var DECLARATIONS = [SelectPipe];
var ApolloModule = /*#__PURE__*/_createClass(function ApolloModule() {
  _classCallCheck(this, ApolloModule);
});
ApolloModule.decorators = [{
  type: NgModule,
  args: [{
    providers: PROVIDERS,
    declarations: DECLARATIONS,
    exports: DECLARATIONS
  }]
}];

/**
 * Generated bundle index. Do not edit.
 */

export { APOLLO_NAMED_OPTIONS, APOLLO_OPTIONS, Apollo, ApolloBase, ApolloModule, Mutation, Query, QueryRef, SelectPipe, Subscription, PROVIDERS as ɵa, DECLARATIONS as ɵb };